import { gql, useMutation } from "@apollo/client";

export const SEND_API_KEY = gql`
    mutation SendApiKeyToItEmail($channelId: Long!, $confirmationText: String!) {
        sendApiKeyToItEmail(channelId: $channelId, confirmationText: $confirmationText)
    }
`;

export interface SendApiKeyResponse {
    sendApiKeyToItEmail: boolean;
}

export interface SendApiKeyVariables {
    channelId: number;
    confirmationText: string;
}

export const useSendApiKey = () => {
    return useMutation<SendApiKeyResponse, SendApiKeyVariables>(SEND_API_KEY);
};

